<div class="edit-floorplan-container">
  <div style="
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 32px;
      border-bottom: 1px solid rgba(222, 222, 222, 0.2);
    ">
    <div style="font-weight: 700; font-size: 18px; color: #dedede">
      {{ isEdit ? "Edit" : "Add a New" }} Floorplan
    </div>
    <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer" (click)="cancel()">
      close
    </mat-icon>
  </div>
  <mat-horizontal-stepper class="floorplan-stepper" [linear]="!isEdit" #stepper [selectedIndex]="currentStep"
                          labelPosition="bottom">
    <ng-template matStepperIcon="information">
      <mat-icon>done</mat-icon>
    </ng-template>
    <mat-step [stepControl]="firstFormGroup" state="information" selectedIndex="2">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Information</ng-template>
        <div fxLayout="row" fxLayoutAlign="space-between">
          <div fxLayout="column" fxFlex="48">
            <!-- <div class="field-label">Floorplan Name</div> -->
            <mat-form-field appearance="outline">
              <mat-label>Floorplan Name</mat-label>
              <input matInput formControlName="notes" placeholder="Floorplan Name" required/>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between">
          <div fxLayout="column" fxFlex="48">
            <mat-form-field appearance="outline">
              <mat-label>Bedroom</mat-label>
              <input matInput formControlName="bedRoom" type="number"
                     onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                     placeholder="Floorplan BedRoom"/>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxFlex="48">
            <mat-form-field appearance="outline">
              <mat-label>Bathroom</mat-label>
              <input matInput formControlName="bathRoom" type="text"
                     placeholder="Floorplan BethRoom"
                     (input)="validateInput($event)"/>
            </mat-form-field>
          </div>
        </div>
        <div fxLayoutAlign="end">
          <button mat-button matStepperNext (click)="updateFloorplan()" class="confirm-button">
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Floorplans</ng-template>

      <div class="upload-image" *ngIf="floorPlan">
        <div class="floorplan-dropzone" accept="image/*" ngx-dropzone (change)="onImageSelect($event)">
          <ngx-dropzone-label class="floorplan-dropzone-label" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon class="icon-upload" style="color: #c4c4c4">add</mat-icon>
          </ngx-dropzone-label>

          <div *ngIf="floorPlan && floorPlan.images && floorPlan.images.length" class="floorplan-images-preview"
               fxLayout="row wrap" fxLayoutAlign="start start">
            <!-- 已存在的图片 -->
            <custom-dropzone-preview class="preview-item" ngProjectAs="ngx-dropzone-preview"
                                     [imageSrc]="getImageUrl(image.fileName)" *ngFor="let image of floorPlan.images"
                                     [removable]="true"
                                     (removed)="onImageRemove(image)">
            </custom-dropzone-preview>

            <div class="drag-box" fxLayout="row" fxLayoutAlign="center center">
              <mat-icon class="icon-upload" style="color: #c4c4c4">add</mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div fxLayoutAlign="end" fxLayoutGap="10px">
        <button mat-button matStepperPrevious class="confirm-button">
          Back
        </button>
        <button mat-button matStepperNext class="confirm-button">Next</button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>AR Settings</ng-template>

      <div *ngIf="floorPlan">
        <div style="
            font-weight: 400;
            font-size: 14px;
            color: #dedede;
            margin: 24px 0;
          ">
          The file size is less than 30MB. This step is optional.
        </div>

        <div class="ar-item-title">ios</div>
        <div *ngIf="
            (!floorPlan.urls || !floorPlan.urls.ios) &&
            !iosFileProgress.isUploading
          " class="floorplan-ar-file" [multiple]="false" accept=".usdz" ngx-dropzone
             (change)="onFileSelect($event, 'ios')">
          <ngx-dropzone-label class="floorplan-dropzone-label" fxLayout="row" fxLayoutAlign="center center"
                              fxLayoutGap="24px">
            <div class="upload_box flex align-center">
              <img src="./assets/images/black/upload.png" class="upload_image mr_20"/>
              <div>
                <div class="flex fz_16">
                  <div style="text-decoration-line: underline; color: #2142ff">
                    Choose a file
                  </div>
                  <div style="color: rgba(222, 222, 222, 0.4); margin-left: 5px">
                    or drag it here
                  </div>
                </div>
                <div class="fz_14 mt_10" style="color: rgba(222, 222, 222, 0.4)">
                  The file size is less than 30MB. This step is optional.
                </div>
              </div>
            </div>
            <!-- <div style="font-size: 12px;">drag here or choose file</div> -->
          </ngx-dropzone-label>
        </div>
        <div *ngIf="iosFileProgress.isUploading" class="floorplan-file-preview">
          <div>{{ iosFileProgress.filename }}</div>
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="6px">
            <div fxFlex="94" class="progress-bar-wrap">
              <div class="progress-bar" [style.width.%]="iosFileProgress.progress"></div>
            </div>
            <div fxLayoutAlign="center center">
              <mat-icon (click)="cancelIosUpload()" style="font-size: 16px; width: 16px; height: 16px">close</mat-icon>
            </div>
          </div>
        </div>
        <div *ngIf="
            floorPlan.urls && floorPlan.urls.ios && !iosFileProgress.isUploading
          " class="floorplan-file-preview" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="20px">
          <div>{{ floorPlan.urls.ios }}</div>
          <div fxLayoutGap="20px">
            <mat-icon (click)="openFile(floorPlan.urls.ios)">download</mat-icon>
            <mat-icon (click)="onFileRemove('ios')">delete</mat-icon>
          </div>
        </div>

        <div class="ar-item-title">android</div>
        <div *ngIf="
            (!floorPlan.urls || !floorPlan.urls.android) &&
            !androidFileProgress.isUploading
          " class="floorplan-ar-file" [multiple]="false" accept=".glb" ngx-dropzone
             (change)="onFileSelect($event, 'android')">
          <ngx-dropzone-label class="floorplan-dropzone-label" fxLayout="row" fxLayoutAlign="center center"
                              fxLayoutGap="24px">
            <div class="upload_box flex align-center">
              <img src="./assets/images/black/upload.png" class="upload_image mr_20"/>
              <div>
                <div class="flex fz_16">
                  <div style="text-decoration-line: underline; color: #2142ff">
                    Choose a file
                  </div>
                  <div style="color: rgba(222, 222, 222, 0.4); margin-left: 5px">
                    or drag it here
                  </div>
                </div>
                <div class="fz_14 mt_10" style="color: rgba(222, 222, 222, 0.4)">
                  The file size is less than 30MB. This step is optional.
                </div>
              </div>
            </div>
            <!-- <div style="font-size: 12px;">drag here or choose file</div> -->
          </ngx-dropzone-label>
        </div>
        <div *ngIf="androidFileProgress.isUploading" class="floorplan-file-preview">
          <div>{{ androidFileProgress.filename }}</div>
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="6px">
            <div fxFlex="94" class="progress-bar-wrap">
              <div class="progress-bar" [style.width.%]="androidFileProgress.progress"></div>
            </div>
            <div fxLayoutAlign="center center">
              <mat-icon (click)="cancelAndroidUpload()" style="font-size: 16px; width: 16px; height: 16px">close
              </mat-icon>
            </div>
          </div>
        </div>
        <div *ngIf="
            floorPlan.urls &&
            floorPlan.urls.android &&
            !androidFileProgress.isUploading
          " class="floorplan-file-preview">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div>{{ floorPlan.urls.android }}</div>
            <div fxLayoutGap="20px">
              <mat-icon (click)="showPreviewContent()">remove_red_eye</mat-icon>
              <mat-icon (click)="openFile(floorPlan.urls.android)">download</mat-icon>
              <mat-icon (click)="onFileRemove('android')">delete</mat-icon>
            </div>
          </div>

          <model-viewer *ngIf="showAndroidFilePreview" style="width: 100%; height: 350px" camera-controls ar
                        ar-modes="webxr scene-viewer quick-look" [src]="getFileUrl(floorPlan.urls.android)"
                        [alt]="floorPlan.urls.android" data-js-focus-visible="" ar-status="not-presenting">
          </model-viewer>
        </div>
      </div>
      <div fxLayoutAlign="end" fxLayoutGap="10px">
        <button mat-button matStepperPrevious class="confirm-button">
          Back
        </button>
        <button mat-button (click)="cancel()" class="confirm-button">
          Confirm
        </button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
